import { gql } from "@apollo/client";

export const SELECT_TRIALS = gql`
  query GetAllTrialCalendar(
    $pageNumber: Int!
    $pageSize: Int!
    $role: String
    $approvalStatus: String
    $excludeShared: Boolean
  ) {
    getAllTrialCalendar(
      pageNumber: $pageNumber
      pageSize: $pageSize
      role: $role
      approvalStatus: $approvalStatus
      excludeShared: $excludeShared
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        id
        trial {
          trialName
        }
      }
    }
  }
`;
